import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useLocale } from 'react-intlayer'
import { SupportView } from '@/components/support-view'

export const Route = createFileRoute('/support/')({ component: Page })
function Page() {
  const { locale } = useLocale()
  const navigate = useNavigate()
  return (
    <SupportView
      locale={locale === 'en' ? 'en' : 'ja'}
      onSelect={(slug) => {
        void navigate({ to: '/support/$slug', params: { slug } })
      }}
    />
  )
}
